/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23 42V38H19V35H23V29.9C20.2667 29.5333 18 28.3083 16.2 26.225C14.4 24.1417 13.5 21.7167 13.5 18.95C13.5 15.9167 14.575 13.3333 16.725 11.2C18.875 9.06667 21.4667 8 24.5 8C27.5333 8 30.125 9.06667 32.275 11.2C34.425 13.3333 35.5 15.9167 35.5 18.95C35.5 21.7167 34.6 24.1417 32.8 26.225C31 28.3083 28.7333 29.5333 26 29.9V35H30V38H26V42H23ZM24.5 27C26.7 27 28.5833 26.2167 30.15 24.65C31.7167 23.0833 32.5 21.2 32.5 19C32.5 16.8 31.7167 14.9167 30.15 13.35C28.5833 11.7833 26.7 11 24.5 11C22.3 11 20.4167 11.7833 18.85 13.35C17.2833 14.9167 16.5 16.8 16.5 19C16.5 21.2 17.2833 23.0833 18.85 24.65C20.4167 26.2167 22.3 27 24.5 27Z" fill="#262626" />
  </svg>
);

export default SvgComponent;
